import { render } from "./PillDefault.vue?vue&type=template&id=7235ed6c"
import script from "./PillDefault.vue?vue&type=script&lang=js"
export * from "./PillDefault.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__